console.log("WE", process.env);

export const BACKEND_PATH = process.env.REACT_APP_BACKEND_PATH;
export const CMS_PATH = process.env.REACT_APP_CMS_PATH;
